/**
 * The combination of the topic and its message (if any).
 */
export type GlobalMessage = Record<GlobalMessageTopic, GlobalMessagePayload | undefined>;

/**
 * The list of topics that we want to show via the global message popup.
 */
export enum GlobalMessageTopic {
  MISWIRED = 'miswired',
}

/**
 * The message payload shape, consist of message level and message content.
 */
export type GlobalMessagePayload = {
  level: GlobalMessageLevel;
  msg: string;
};

/**
 * The level of the global message.
 * Currently only ERROR is used
 */
export enum GlobalMessageLevel {
  // INFO = 'info',
  // WARN = 'warn',
  ERROR = 'error',
}
